import { useEffect, useState } from 'react';
import { Button, Image } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import commonApi from 'apis/common';
import classNames from 'classnames';

type PrivateReceiptImageProps = {
  imageKey: string;
  width?: number;
  onRemove?: (imageKey: string) => void;
  className?: string;
};

const PrivateReceiptImage = ({
  imageKey,
  width = 60,
  onRemove,
  className,
}: PrivateReceiptImageProps) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    commonApi.getSignedFileUrl(imageKey).then((res) => {
      setImageUrl(res.url);
    });
  }, [imageKey]);

  if (!imageUrl) return null;

  return (
    <div className={classNames('relative inline-flex', className)}>
      <Image src={imageUrl} width={width} />
      {onRemove ? (
        <Button
          danger
          size="small"
          className="absolute top-0 right-0"
          icon={<CloseOutlined />}
          onClick={() => onRemove(imageKey)}
        />
      ) : null}
    </div>
  );
};

export default PrivateReceiptImage;
